import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Rate,Modal,Button   } from 'antd';
import { Bar } from 'react-chartjs-2';



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			total_school: 0,
			value: '',
			aToken: '',
			fees_modal: false,
			modal_title:'',
			modal_value:'',
			program_id:'',
			division:'',
			child_data: [],
			graph_data: [],
			program_list: [],
			division_list: [],
			theme_list: [],
			academic_year_: [],
			academic_year: '',
			theme_id: '',
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.openQuantity = this.openQuantity.bind(this);
		this.change_division = this.change_division.bind(this);
		this.change_theme = this.change_theme.bind(this);
		this.change_year = this.change_year.bind(this);
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
					academic_year : new_acad,
				});
			}, 50);
		}
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		getData('erp/new_program_list',app).then((result) => {
		let responseJson = result;
		if(responseJson.data){
			if(result['status'] == 200){
					this.setState({
						program_list: result['data'],
						program_id: result['data'][0]['id'],
					});
				setTimeout(() => {	
					this.openQuantity1(result['data'][0]['id']);
				}, 100);	
			}else{
				this.setState({
					program_list: [],
					program_id: '',
					
				});
			}
			}
		});
		getData('common/tracker_theme_list',app).then((result) => {
		let responseJson = result;
		if(responseJson.data){
			if(result['status'] == 200){
					this.setState({
						theme_list: result['data'],
						theme_id: result['data'][0]['id'],
					});	
			}else{
				this.setState({
					theme_list: [],
					theme_id: '',
					
				});
			}
			}
		});
		getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
							academic_year: result['current_year'],
						});
					}else{
						this.setState({
							academic_year_: [],
						});
					}
				}
			});	
		
		setTimeout(() => {
			this.checkData();
		}, 500);
	}
	
	openQuantity1(e){
		var app = {user_id : this.state.user_id,program_id:e,school_id:this.state.school_id}
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
						division: result['data'][0]['id'],
					});
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});
	}
	
	openQuantity(e){
		this.setState({ program_id: e.target.value,division:'',division_list:[] });
		var app = {user_id : this.state.user_id,program_id:e.target.value,school_id:this.state.school_id,}
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
						division: result['data'][0]['id'],
					});
				}else{
					this.setState({
						division_list: [],
						division: '',
					});
				}
			}
		});
	} 
	
	change_division(e){
		this.setState({ division: e.target.value });
	}  
	
	change_theme(e){
		this.setState({ theme_id :  e.target.value });
	}  
	
	change_year(event){
		this.setState({academic_year: event.target.value});
	}
	
	handleSubmit(e){
		setTimeout(() => {
			this.checkData();
		}, 50);
	} 
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var student_theme_id = this.state.theme_id;
			var division_id = this.state.division;
			var class_id = this.state.program_id;
			var academic_year = this.state.academic_year;
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			var app = {academic_year : academic_year,student_theme_id : student_theme_id,division_id : division_id,class_id : class_id,school_id:school_id,user_id:user_id}
			getData('GraphApi/class_tracker',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							graph_data: result['data'],
							total_school: result['total_school'],
							//graph_data: result['data'][0]['graph_data'],
						});
					}else{
						this.setState({
							graph_data: [],
							total_school: 0,
							//graph_data: [],
						});
					}
				}
			});
		}
    }
	
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	RequestFess = (request,value) => {
		this.setState({ fees_modal : true,modal_title:request,modal_value:value });
	};
	
	handleCancel   = () => {
		this.setState({ fees_modal: false,modal_title:'',modal_value:'' });
	};
	
	
  

	render()

	{
	const {aToken}=this.state;
	const graph_data = {
  labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4', 'Label 5', 'Label 6'],
  datasets: [
    {
      label: 'Sample Horizontal Bar Graph',
      data: [12, 19, 3, 5], // Fewer data points compared to the labels
      backgroundColor: 'rgba(75, 192, 192, 0.6)', // Customize the bar color
      borderColor: 'rgba(75, 192, 192, 1)', // Customize the border color
      borderWidth: 1,
    },
  ],
};
	const options = {
	  scales: {
		y: {
		  beginAtZero: false,
		  ticks: {
			callback: function (value) {
			  return value + '%';
			},
		  },
		},
		 yAxes: [{
		  scaleLabel: {
		    beginAtZero: true,
			display: true,
			labelString: 'Number Of Student',
		  }
		}],
		xAxes: [{
		  scaleLabel: {
			display: true,
			labelString: 'Star'
		  }
		}],

	  },
	};
					
		return (
			<>
				
				<Modal className="pay-fees-modal trackermodel" title={`${this.state.modal_title}`} visible={this.state.fees_modal} onOk={this.handleCancel.bind(this)} onCancel={this.handleCancel.bind(this)} >
						<div class="row">
						<div class="col-md-12 mt-20 ">
							<div dangerouslySetInnerHTML={{ __html: this.state.modal_value }} />
						
						</div>
						
						
						</div>
				</Modal>
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card ">
							<div class="card-body ">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Class Wise Tracker
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Class Wise Tracker</li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						
						<div class="row">
							<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Academic Year </b></label>
								<select  placeholder="Select Academic Year" value={this.state.academic_year} className="form-control changeSchool" onChange={this.change_year.bind(this)}>
									{this.state.academic_year_.map((list)=>(
										<option value={list.name}>{list.name}</option>
									))}	
								</select>
							</div>
							</div>
							<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Class</b></label>
								 <select  placeholder="Select Class" value={this.state.program_id} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.openQuantity.bind(this)}>
									{this.state.program_list.map((list)=>(
										<option value={list.id}>{list.name}</option>
									))}	
								 </select>
							</div>
							</div>
							<div class="col-md-2 ">
								<div class="form-group">
									<label  style={{paddingTop: '8px'}}><b>Division</b></label>
									 <select  placeholder="Select Class" value={this.state.division} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.change_division.bind(this)}>
										{this.state.division_list.map((list)=>(
											<option value={list.id}>{list.name}</option>
										))}	
									 </select>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label  style={{paddingTop: '8px'}}><b>Theme</b></label>
									 <select  placeholder="Select Class" value={this.state.theme_id} name="theme_id" id="theme_id" className="form-control changeSchool" onChange={this.change_theme.bind(this)}>
										{this.state.theme_list.map((list)=>(
											<option value={list.id}>{list.name}</option>
										))}	
									 </select>
								</div>
							</div>
						
						<div class="col-md-2">
							<div class="form-group">
								 <label  style={{paddingTop: '8px'}}>&nbsp;</label>
								 <Button className="btn btn-primary mr-2" style={{display: 'block'}} id="submit_btn" onClick={this.handleSubmit.bind(this)} >Apply</Button>
							</div>
						</div>
						
						</div>
						
					</div>
					</div>
					</div>
				</div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 graph-d">
						<div class="row">
						<div class="col-md-12">
							<div class="student-fees-border">
								<div class="col-md-12">
									<span class="title">Graph</span>
								</div>
								{this.state.total_school > 0 ? (<>
								<Bar data={this.state.graph_data} options={options} height={120} />
								</>) :(<>
									<div class="row">
									<div class="col-md-12">
										<h5 class="center">No Tracker Found !! </h5>
									</div>
									</div>
								 
								</>)}
								
							</div>
							
						</div>
						
						</div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
